module.exports = __webpack_public_path__ + "static/media/type-1.a202bce7.svg";